export default __webpack_public_path__ + "static/logoV2-50874a4a0c4487560ff457839612a12d.svg";